import {
  accessRestrictions,
  Identifiable,
  Planzone,
  RestrictedAreas,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function deserializeRestrictions(settings: { [key: string]: string }) {
  const restrictedAreas: RestrictedAreas[] = [
    "personalSynthesis",
    "personalTimesheet",
    "resources",
    "costProfiles",
    "projectTemplates",
    "projectReportsTemplate",
    "projectStatuses",
    "portfolios",
    "calendar",
    "strategicAxes",
    "exports",
    "onlyOffice",
    "documents",
  ];

  return restrictedAreas.reduce(
    (restrictions, area) =>
      typeof settings[`restrictions.${area}`] === "string"
        ? {
            ...restrictions,
            [area]: settings[`restrictions.${area}`].split(","),
          }
        : restrictions,
    accessRestrictions,
  );
}

function getAccessRestrictions(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Planzone>) =>
    httpClient
      .sendHttpRequest<Identifiable<Planzone>>({
        endpoint: `/planzones/${uuid}`,
        method: HttpMethods.GET,
      })
      .then(({ settings }) => deserializeRestrictions(settings));
}

export { getAccessRestrictions };
